import React, { Fragment, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import { addFotaJob, updateFotaJob } from "../../action/fotaJobs";
import customConfig from "../../config";
import { selectMenuProps } from "../../utils/selectMenuProps";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const FotaJobForm = ({
  job,
  addFotaJob,
  updateFotaJob,
  fotaJobsData: { fotaJobAddSucces, fotaJobUpdateSucces },
  notifySuccess,
}) => {
  useEffect(() => {
    if (fotaJobAddSucces || fotaJobUpdateSucces) {
      notifySuccess();
    }
  }, [fotaJobAddSucces, fotaJobUpdateSucces]);

  const weekdays = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

  const getInitialWeekDays = () => {
    let dayList = [];
    if (job && job.frequency.day_of_week) {
      let wDays = job.frequency.day_of_week;
      // check if "-" separated day list
      let splitDays = wDays.split("-");
      if (splitDays.length > 1) {
        let firstDay = splitDays[0];
        let lastDay = splitDays[1];
        let started = false;
        for (const d of weekdays) {
          if (d === firstDay) {
            started = true;
          }
          if (started) {
            dayList.push(d);
          }
          if (d === lastDay) {
            break;
          }
        }
      } else {
        // check if "," separated day list
        let splitDays = wDays.split(",");
        if (splitDays.length > 1) {
          for (const d of splitDays) {
            dayList.push(d);
          }
        } else {
          // Add single day
          dayList.push(wDays);
        }
      }
    }
    return dayList;
  };

  const getInitialEndDate = () => {
    if (job) {
      return new Date(job.endDate.$date);
    } else {
      var newEndDate = new Date();
      return new Date(
        newEndDate.getTime() +
          customConfig.fotaJobDefaultDurationInDays * 24 * 60 * 60 * 1000
      );
    }
  };

  const getInitialHour = () => {
    if (job) {
      let jobHour = Number(job.frequency.hour);
      if (jobHour === 0) {
        return "12";
      } else if (jobHour > 12) {
        return (jobHour - 12).toString();
      } else {
        return job.frequency.hour;
      }
    } else {
      return "12";
    }
  };

  const getWeekDays = () => {
    let sequence = true;
    let started = false;
    let finished = false;
    let startDay;
    let endDay;
    for (const d of weekdays) {
      if (daysOfWeek.includes(d)) {
        if (!started) {
          started = true;
          startDay = d;
        }
        if (finished) {
          sequence = false;
          break;
        }
        endDay = d;
      }
      if (started && !daysOfWeek.includes(d)) {
        finished = true;
      }
    }

    if (sequence) {
      return `${startDay}-${endDay}`;
    } else {
      return daysOfWeek.toString();
    }
  };

  const getHour = () => {
    if (hour === "12" && meridiem === "AM") {
      return "0";
    } else if (hour !== "12" && meridiem === "PM") {
      return (12 + Number(hour)).toString();
    } else {
      return hour;
    }
  };

  const [jobName, setJobName] = useState(job ? job.name : "");
  const [endDate, setEndDate] = useState(() => getInitialEndDate());
  const [daysOfWeek, setDaysOfWeek] = useState(() => getInitialWeekDays());
  const [hour, setHour] = useState(() => getInitialHour());
  const [minute, setMinute] = useState(job ? job.frequency.minute : "0");
  const [meridiem, setMeridiem] = useState(
    job && Number(job.frequency.hour) >= 12 ? "PM" : "AM"
  );

  const handleDayToggle = (day) => {
    if (daysOfWeek.includes(day)) {
      setDaysOfWeek(daysOfWeek.filter((d) => d !== day));
    } else {
      setDaysOfWeek([...daysOfWeek, day]);
    }
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const resetFotaJob = () => {
    setJobName(job.name);
    setEndDate(getInitialEndDate());
    setDaysOfWeek(getInitialWeekDays());
    setHour(getInitialHour());
    setMinute(job.frequency.minute);
    setMeridiem(Number(job.frequency.hour) >= 12 ? "PM" : "AM");
  };

  const validateFields = () => {
    const format = /[`!@#$%^&*()+\-=\[\]{};':"\\|<>\/?~]/;
    if (!(jobName && jobName.trim().length > 0)) {
      alert(customConfig.fotaJobNameNeededMsg);
      return false;
    }
    if (format.test(jobName)) {
      alert(customConfig.specialCharsNotAllowed);
      return false;
    }
    if (!endDate) {
      alert(customConfig.fotaJobEndDateNeededMsg);
      return false;
    }
    if (daysOfWeek.length === 0) {
      alert(customConfig.fotaJobWeekDayNeededMsg);
      return false;
    }

    return true;
  };

  const saveFotaJob = () => {
    if (validateFields()) {
      let endDateUnixTimeStamp = parseInt(endDate.getTime() / 1000);
      if (job) {
        updateFotaJob(
          job.jobId,
          jobName.trim(),
          endDateUnixTimeStamp,
          getWeekDays(),
          getHour(),
          minute
        );
      } else {
        addFotaJob(
          jobName.trim(),
          endDateUnixTimeStamp,
          getWeekDays(),
          getHour(),
          minute
        );
      }
    }
  };

  return (
    <Fragment>
      <div className="p-25 form-style-modal" style={{ width: "100%", minWidth: 0, boxSizing: "border-box" }}>
        <div className="block-title style-2 mb-20 center-align">
          <h3 className="mb-0">{job ? "Update Job" : "Add new Job"}</h3>
        </div>

        <div className="row">
          <div className="input-field p-0 m-0 col s12">
            <label className="active">Job Name</label>
            <input
              type="text"
              placeholder="Enter job title"
              className="add-input"
              value={jobName}
              onChange={(e) => setJobName(e.target.value)}
              style={{ width: "100%", boxSizing: "border-box" }}
            />
          </div>
        </div>

        <div className="row">
          <div className="input-field p-0  m-0 col s12">
            <label className="active"> End Date</label>
            <DatePicker
              selected={endDate}
              minDate={new Date()}
              onChange={handleEndDateChange}
              placeholder="MM-DD-YYYY"
              className="add-input calendar"
              style={{ width: "100%", boxSizing: "border-box" }}
            />
          </div>
        </div>

        <div className="row">
          <div className="p-0  m-0 input-field col s12">
            <label className="active">Days of Week</label>
            <div className="wweek-box  d-flex">
              <div
                className={
                  daysOfWeek && daysOfWeek.includes("mon")
                    ? "name active"
                    : "name"
                }
                onClick={() => handleDayToggle("mon")}
              >
                Mon
              </div>
              <div
                className={
                  daysOfWeek && daysOfWeek.includes("tue")
                    ? "name active"
                    : "name"
                }
                onClick={() => handleDayToggle("tue")}
              >
                Tue
              </div>
              <div
                className={
                  daysOfWeek && daysOfWeek.includes("wed")
                    ? "name active"
                    : "name"
                }
                onClick={() => handleDayToggle("wed")}
              >
                Wed
              </div>
              <div
                className={
                  daysOfWeek && daysOfWeek.includes("thu")
                    ? "name active"
                    : "name"
                }
                onClick={() => handleDayToggle("thu")}
              >
                Thu
              </div>
              <div
                className={
                  daysOfWeek && daysOfWeek.includes("fri")
                    ? "name active"
                    : "name"
                }
                onClick={() => handleDayToggle("fri")}
              >
                Fri
              </div>
              <div
                className={
                  daysOfWeek && daysOfWeek.includes("sat")
                    ? "name active"
                    : "name"
                }
                onClick={() => handleDayToggle("sat")}
              >
                Sat
              </div>
              <div
                className={
                  daysOfWeek && daysOfWeek.includes("sun")
                    ? "name active"
                    : "name"
                }
                onClick={() => handleDayToggle("sun")}
              >
                Sun
              </div>
            </div>
          </div>
        </div>

        <div className="row time-row-responsive">
          <div className="input-field p-0 m-0 col s12 m5">
            <div className="control-capabilities select-height">
              <label className="active"> Hour</label>
              <div className="model-srch reset">
                <FormControl variant="outlined" size="small" fullWidth>
                  <Select
                    value={hour}
                    onChange={(e) => setHour(e.target.value)}
                    MenuProps={selectMenuProps}
                  >
                    {[1,2,3,4,5,6,7,8,9,10,11,12].map((n) => (
                      <MenuItem key={n} value={String(n)}>{n}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
          <div className="input-field p-0 m-0 col s12 m5">
            <div className="control-capabilities select-height">
              <label className="active">Minute</label>
              <div className="model-srch reset">
                <FormControl variant="outlined" size="small" fullWidth>
                  <Select
                    value={minute}
                    onChange={(e) => setMinute(e.target.value)}
                    MenuProps={selectMenuProps}
                  >
                    {Array.from({ length: 60 }, (_, i) => (
                      <MenuItem key={i} value={String(i)}>{i}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
          <div className="input-field p-0 m-0 col s12 m2">
            <div className="control-capabilities">
              <label className="active">AM/PM</label>
              <div className="model-srch reset">
                <FormControl variant="outlined" size="small" fullWidth>
                  <Select
                    value={meridiem}
                    onChange={(e) => setMeridiem(e.target.value)}
                    MenuProps={selectMenuProps}
                  >
                    <MenuItem value="AM">AM</MenuItem>
                    <MenuItem value="PM">PM</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex flex-end">
          {job && (
            <button
              className="btn btn-style-2 dark-text gray-bg"
              style={{ marginRight: "12px" }}
              onClick={() => resetFotaJob()}
            >
              Reset
            </button>
          )}
          <button
            className="btn btn-style-2 orange-bg"
            onClick={() => saveFotaJob()}
          >
            {job ? "Update Job" : "Create Job"}
          </button>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  fotaJobsData: state.fotaJobs,
});

export default connect(mapStateToProps, { addFotaJob, updateFotaJob })(
  FotaJobForm
);
